<table class='table table-silver'>
  <thead>
  <tr>
    <th style='width: 20rem'></th>
    <th>
      Szerokość
    </th>
    <th>
      Długość
    </th>
    <th>
      Powierzchnia
    </th>
  </tr>
  </thead>
  <tbody>
  <tr *ngIf='stage?.roadArea2'>
    <td class='align-left'>
      <strong>
        Jezdnia
      </strong>
      <br>
      <small>(Do 50% szerokości jezdni)</small>
    </td>
    <td>
      {{ stage?.roadWidth2 | toNumber | number }} m
    </td>
    <td>
      {{ stage?.roadLength2 | toNumber | number }} m
    </td>
    <td>
      {{ stage?.roadArea2 | toNumber | number }} m<sup>2</sup>
    </td>
  </tr>
  <tr *ngIf='stage?.roadArea3'>
    <td class='align-left'>
      <strong>
        Jezdnia
      </strong>
      <br>
      <small>(Powyżej 50% szerokości jezdni)</small>
    </td>
    <td>
      {{ stage?.roadWidth3 | toNumber | number }} m
    </td>
    <td>
      {{ stage?.roadLength3 | toNumber | number }} m
    </td>
    <td>
      {{ stage?.roadArea3 | toNumber | number }} m<sup>2</sup>
    </td>
  </tr>
  <tr *ngIf='stage?.sidewalkArea'>
    <td class='align-left'>
      <strong>
        Chodnika, zatoki postojowej, <br> parkingu, ścieżki rowerowej
      </strong>
    </td>
    <td>
      {{ stage?.sidewalkWidth | toNumber | number }} m
    </td>
    <td>
      {{ stage?.sidewalkLength | toNumber | number }} m
    </td>
    <td>
      {{ stage?.sidewalkArea | toNumber | number }} m<sup>2</sup>
    </td>
  </tr>
  <tr *ngIf='stage?.otherElementsArea'>
    <td class='align-left'>
      <strong>
        Pozostałe elementy pasa drogowego
      </strong>
      <small>(zieleni, rowu, pobocza)</small>
    </td>
    <td>
      @if (stage?.otherElementsWidth; as otherElementsWidth) {
        {{ otherElementsWidth | toNumber | number }} m
      }
    </td>
    <td>
      @if (stage?.otherElementsLength; as otherElementsLength) {
        {{ otherElementsLength | toNumber | number }} m
      }
    </td>
    <td>
      @if (stage?.otherElementsArea; as otherElementsArea) {
        {{ otherElementsArea | toNumber | number }} m<sup>2</sup>
      }
    </td>
  </tr>
  <tr *ngIf='stage?.roadArea'>
    <td class='align-left'>
      <strong>
        Powierzchnia w odniesieniu do obiektów i urządzeń infrastruktury telekomunikacyjnej
      </strong>
    </td>
    <td>
      {{ stage?.roadWidth | toNumber | number }} m
    </td>
    <td>
      {{ stage?.roadLength | toNumber | number }} m
    </td>
    <td>
      {{ stage?.roadArea | toNumber | number }} m<sup>2</sup>
    </td>
  </tr>
  </tbody>
</table>
